module.exports = __webpack_public_path__ + "img/wein-kultur-mobil.53d16d9b.jpg";